import React from "react"
const platform = process.env.REACT_APP_PLATFORM

export const Login = () => {
    localStorage.clear()
    const login = `https://accounts.kore.co/login?platform=${platform}`
    window.location.href = login
}